import React from 'react';
import '../assets/css/manager.css';
import userbig from "../assets/img/userbig.png";
import {useSelector} from "react-redux";
import Api from "../Api.js";
import SuccessToast from "./BlueButton/SuccessToast.js";
import ErrorToast from "./BlueButton/ErrorToast.js";

const StaffItem = ({ image,getData, name, surname,id, profession }) => {
    const login = useSelector((state) => state.manager.employee);
    const deleteFileBeforeAccept =async ( ) =>{
        try {
            let text = "Վստա՞հ եք, որ ցանկանում եք ջնջել";

            if (confirm(text) === true) {
                await Api.deleteAccount(id)
                getData()
                SuccessToast()

            }

        } catch (e) {
            console.log(e)
            ErrorToast()
        }
    }

    return (
        <div className='list-item'>
            <div
                className='list-item-img'
                style={{ backgroundImage: image ? `url(${image})` : `url(${userbig})` }}>
            </div>

            <div className='list-item-data'>
                <span className='list-item-name-surname'>{name}</span>
                <span className='list-item-name-surname'>{surname}</span>
                <p className='profession'>{profession}</p>
            </div>
            {(login.user_id === 86 || login.user_id === 1918 || login.user_id === 1024 || login.user_id === 2) && id?<div className="tool-tip-cont" style={{right:10}}>
                <div className="tool-tip">Ջնջել</div>
                <i className="fas fa-trash-alt"
                   onClick={(e) => {
                       e.preventDefault(); // ⛔ Stops <Link> navigation
                       e.stopPropagation();
                       deleteFileBeforeAccept()
                   }}/>
            </div>:null}
        </div>
    );
};

export default StaffItem;
